import { get, set } from 'lodash'

class VersionControl {
    constructor(versionsList = [], migrationTree = []) {
        this.versionsList = versionsList
        this.migrationTree = migrationTree.reduce((map, el) => {
            map[el.version] = {
                downgrade: el.downgrade,
                upgrade: el.upgrade,
            }
            return map
        }, {})
    }

    migrate(data, version, versionField = '_v') {
        try {
            const currentVersion = get(data, versionField)

            if (currentVersion !== version) {
                const strategy =
                    this.versionsList.indexOf(currentVersion) > this.versionsList.indexOf(version)
                        ? 'downgrade'
                        : 'upgrade'
                console.log(`[VC] Start migrate from ${currentVersion} (${strategy.toUpperCase()})`)
                const f = this.migrationTree[currentVersion][strategy]
                if (f) {
                    const result = f(data)
                    set(result.data, versionField, result.version)
                    console.log(`[VC] Migrating successful`)
                    return this.migrate(result.data, version, versionField)
                } else {
                    throw new Error(`Cannot find ${strategy.toUpperCase()} function`)
                }
            }
            console.log(`[VC] Successfully migrated to ${version}`)
            return {
                isSuccess: true,
                data,
            }
        } catch (err) {
            console.error(err)
            return {
                isSuccess: false,
            }
        }
    }
}

export default VersionControl
